// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdMessagingRulesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      approval_developer_ids: arrayOf(string),
      object_type: string,
      reachable_threshold: number,
      allow_launch_with_approval: boolean,
    })
  ),
});
export const isPostMessagingRulesResponse = objectOf({
  updated_rules_count: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      approval_developer_ids: arrayOf(string),
      object_type: string,
      reachable_threshold: number,
      allow_launch_with_approval: boolean,
    })
  ),
});
